let apiUrl = "";
let baseUrl = "";

switch (process.env.NODE_ENV) {
  case "production":
    // baseUrl = "https://kohler-mini.brandsh.cn";
    // apiUrl = "https://kohler-mini.brandsh.cn/mini.php";
    baseUrl = "https://kohler-mini-prod.brandsh.cn";
    apiUrl = "https://kohler-mini.brandsh.cn/api";
    break;
  case "alpha_demo":
  // baseUrl = "https://demo-kohler-mini.brandsh.cn";
  // apiUrl = "https://demo-kohler-mini.brandsh.cn/mini.php";
  baseUrl = "https://kohler-mini-prod.brandsh.cn";
  apiUrl = "https://demo-kohlermini-formal.brandsh.cn/api";
  break;
  case "development":
    // baseUrl = "https://demo-kohler-mini.brandsh.cn";
    baseUrl = "https://kohler-mini-prod.brandsh.cn";
    // Vue.prototype.IMGURL = 'https://demo-kohler-mini.brandsh.cn'; //run dev使用
    apiUrl = "/api";
    break;
}
export { baseUrl, apiUrl };
